import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Start Details\n          ")
], -1);
const _hoisted_5 = { class: "col-span-6 mt-4" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employeeNumber",
    class: "block text-sm font-medium text-gray-700"
}, "Line manager employee number: *", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "col-span-6 mt-4" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    for: "managerName",
    class: "block text-sm font-medium text-gray-700"
}, "Line manager full name: *", -1);
const _hoisted_11 = ["value", "disabled"];
const _hoisted_12 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_13 = { class: "col-span-6 mt-4" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", {
    for: "reportTo",
    class: "block text-sm font-medium text-gray-700"
}, "Who to report to on day 1: *", -1);
const _hoisted_15 = ["value", "disabled"];
const _hoisted_16 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_17 = { class: "col-span-6 mt-4" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", {
    for: "locationFirstLine",
    class: "block text-sm font-medium text-gray-700"
}, "Work location first line of address: *", -1);
const _hoisted_19 = ["value", "disabled"];
const _hoisted_20 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_21 = { class: "col-span-6 mt-4" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", {
    for: "locationPostcode",
    class: "block text-sm font-medium text-gray-700"
}, "Work location postcode: *", -1);
const _hoisted_23 = ["value", "disabled"];
const _hoisted_24 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_25 = { class: "col-span-6 mt-4" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", {
    for: "reasonableArea",
    class: "block text-sm font-medium text-gray-700"
}, "Reasonable area where the employee could work:", -1);
const _hoisted_27 = ["value", "disabled"];
const _hoisted_28 = { class: "col-span-6 mt-4" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", {
    for: "whereToReport",
    class: "block text-sm font-medium text-gray-700"
}, "Where to report on day 1, if different from usual work\n              location:", -1);
const _hoisted_30 = ["value", "disabled"];
const _hoisted_31 = { class: "col-span-6 mt-4" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("label", {
    for: "startDateTime",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Start date and time: *", -1);
const _hoisted_33 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, [
    /*#__PURE__*/ _createTextVNode("\n            * "),
    /*#__PURE__*/ _createElementVNode("span", { class: "font-bold" }, "Please Note:"),
    /*#__PURE__*/ _createTextVNode(" If a start date has\n            yet to be confirmed please enter 31/12/1999 00:00\n          ")
], -1);
const _hoisted_35 = {
    key: 0,
    class: "col-span-6 mt-4"
};
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", {
    for: "fixedTermEnd",
    class: "block text-sm font-medium text-gray-700"
}, "End date of fixed term contract: *", -1);
const _hoisted_37 = ["value"];
const _hoisted_38 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_39 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_40 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DatePicker = _resolveComponent("DatePicker");
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "employeeNumber-input",
                            value: _ctx.formData?.employeeNumber,
                            type: "text",
                            name: "employeeNumber",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.employeeNumber.$touch()))
                        }, null, 42, _hoisted_7),
                        _createTextVNode(),
                        (_ctx.v$.formData.employeeNumber.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n              * " + _toDisplayString(_ctx.v$.formData.employeeNumber.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "managerName-input",
                            value: _ctx.formData?.managerName,
                            type: "text",
                            name: "managerName",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.managerName.$touch()))
                        }, null, 42, _hoisted_11),
                        _createTextVNode(),
                        (_ctx.v$.formData.managerName.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "\n              * " + _toDisplayString(_ctx.v$.formData.managerName.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "reportTo-input",
                            value: _ctx.formData?.reportTo,
                            type: "text",
                            name: "reportTo",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.reportTo.$touch()))
                        }, null, 42, _hoisted_15),
                        _createTextVNode(),
                        (_ctx.v$.formData.reportTo.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "\n              * " + _toDisplayString(_ctx.v$.formData.reportTo.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "locationFirstLine-input",
                            value: _ctx.formData?.locationFirstLine,
                            type: "text",
                            name: "locationFirstLine",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.locationFirstLine.$touch()))
                        }, null, 42, _hoisted_19),
                        _createTextVNode(),
                        (_ctx.v$.formData.locationFirstLine.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "\n              * " + _toDisplayString(_ctx.v$.formData.locationFirstLine.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "locationPostcode-input",
                            value: _ctx.formData?.locationPostcode,
                            type: "text",
                            name: "locationPostcode",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.locationPostcode.$touch()))
                        }, null, 42, _hoisted_23),
                        _createTextVNode(),
                        (_ctx.v$.formData.locationPostcode.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "\n              * " + _toDisplayString(_ctx.v$.formData.locationPostcode.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createTextVNode(),
                        _createElementVNode("textarea", {
                            id: "reasonableArea-input",
                            value: _ctx.formData?.reasonableArea,
                            name: "reasonableArea",
                            rows: "3",
                            class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[10] || (_cache[10] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                        }, null, 42, _hoisted_27)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createTextVNode(),
                        _createElementVNode("textarea", {
                            id: "whereToReport-input",
                            value: _ctx.formData?.whereToReport,
                            name: "whereToReport",
                            rows: "3",
                            class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[11] || (_cache[11] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                        }, null, 42, _hoisted_30)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createTextVNode(),
                        _createVNode(_component_DatePicker, {
                            value: _ctx.formData?.startDateTime,
                            "time-picker": "",
                            onChange: _ctx.handleDateChange
                        }, null, 8, ["value", "onChange"]),
                        _createTextVNode(),
                        (_ctx.v$.formData.startDateTime.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, "\n              * " + _toDisplayString(_ctx.v$.formData.startDateTime.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _hoisted_34,
                    _createTextVNode(),
                    (_ctx.atr?.formThree?.employmentContract === 'Fixed Term')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _hoisted_36,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "fixedTermEnd-input",
                                value: _ctx.formData?.fixedTermEnd,
                                type: "date",
                                min: "0",
                                name: "fixedTermEnd",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                onInput: _cache[12] || (_cache[12] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.fixedTermEnd.$touch()))
                            }, null, 40, _hoisted_37),
                            _createTextVNode(),
                            (_ctx.v$.formData.fixedTermEnd.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "\n              * " + _toDisplayString(_ctx.v$.formData.fixedTermEnd.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createTextVNode(),
            (_ctx.editable ||
                (!_ctx.disableForm &&
                    _ctx.document.currentStageName === 'offer.notifyPrepOffer'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Next\n        ", 8, _hoisted_40)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
